/* eslint-disable */
import React, { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'

export default function FeaturesModal({
  isOpen = false,
  setIsOpen,
  title,
  featureTitle,
  featureText1,
  featureTitle2,
  featureText2,
  featureTitle3,
  featureText3,
  featureTitle4,
  featureText4
}) {
  function closeModal() {
    setIsOpen(false)
  }

  const openModal = () => {
    setIsOpen(true)
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as='div' className='relative z-10' onClose={closeModal}>
        <Transition.Child as={Fragment}>
          <div
            className='fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm'
            onClick={closeModal}
          />
        </Transition.Child>

        <div className='fixed inset-0  overflow-y-auto md:w-3/5  md:left-52 mb-5 '>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child as={Fragment}>
              <div className='relative flex flex-col items-center text-left p-4 sm:p-6 md:p-10 bg-oya-ghana-modal-background border border-oya-ghana-border shadow-form rounded-xl'>
                <img src='/logo.png' alt='' />
                <div className='flex items-start justify-between'>
                  <div className='flex items-start space-x-4'>
                    <h3 className='font-bold text-3xl lg:5xl pb-4 md:text-oya-ghana-header-h4'>
                      {title}
                    </h3>
                  </div>

                  <div
                    className='border-2 border-oya-ghana-border p-2 rounded-full cursor-pointer ml-5 absolute top-2 right-2'
                    onClick={closeModal}
                  >
                    <XIcon className='h-6 w-6 text-black' aria-hidden='true' />
                  </div>
                </div>
                <div className='flex flex-col  justify-center px-5 '>
                  <div className=''>
                    <h4 className=' font-bold mt-2 text-oya-ghana-green text-oya-ghana-header-h5'>
                      {featureTitle}
                    </h4>
                    <p className='font-medium leading-loose text-xl text-gray-800'>
                      {featureText1}
                    </p>
                  </div>
                  <div className=''>
                    <h4 className=' font-bold mt-2 text-oya-ghana-green text-oya-ghana-header-h5'>
                      {featureTitle2}
                    </h4>
                    <p className='font-medium leading-loose text-xl text-gray-800'>
                      {featureText2}
                    </p>
                  </div>
                  <div className=''>
                    <h4 className=' font-bold mt-2 text-oya-ghana-green text-oya-ghana-header-h5'>
                      {featureTitle3}
                    </h4>
                    <p className='font-medium leading-loose text-xl text-gray-800'>
                      {featureText3}
                    </p>
                  </div>
                  <div className=''>
                    <h4 className=' font-bold mt-2 text-oya-ghana-green text-oya-ghana-header-h5'>
                      {featureTitle4}
                    </h4>
                    <p className='font-medium leading-loose text-xl text-gray-800'>
                      {featureText4}
                    </p>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
